import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngRadio extends ngEditableEx
{
	#target;
	#dataSource;
	#code;
	#value
	
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	async connectedCallback() {

		this.#code = this.getAttribute("code") || "code";
		this.#value = this.getAttribute("codename") || "codename";
		
		var datalist = this.querySelector("datalist");
		
		if (datalist) {
			this.#dataSource = [];
			
			datalist.querySelectorAll("option").forEach(option => {
				const k = option.getAttribute(this.#code);
				const v = option.getAttribute(this.#value);

				if (k && v) {
					this.#dataSource.push({
						[this.#code] : k,
						[this.#value] : v,
					});
				}
			});
		}
		
		
		this.owner	= this.getRootNode().host;//this.closest("nine-grid");
		this.cell	= this.closest("th,td");
		
		const align					= this.closest("th,td").getAttribute("text-align") || "center";
		const justifyContent		= align == "left" ? "flex-start" : (align == "right" ? "flex-end" : "center");
		
		var dataSource = this.getAttribute('data-source');
		if (dataSource && this.owner && this.owner.exprFunction) {

			//const fn = dataSource.replace("()", "");
			if (this.owner[dataSource]) {
				this.#dataSource = this.owner[dataSource];
			}
			else {
				this.#dataSource = this.owner.exprFunction(dataSource).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
			}
			//this.#dataSource = this.owner.exprFunction(dataSource).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
		}
		
		var childHtml	= '';
		if (this.#dataSource) {
			this.#dataSource.forEach(v => {
				//console.log(this.#code, this.#value, v);
				childHtml += `<label><input type="radio" value="${v[this.#code]}"><span>${v[this.#value]}</span></label>`;
			});
		}

		this.shadowRoot.innerHTML = `
			<style>
				div.ng-wrap {
					justify-content: ${justifyContent};
				}
			</style>
			
			<div class="ng-wrap">
				${childHtml}
			</div>
		`;
		
		super.connectedCallback();
		
		this.#init();

		this.#target = this.shadowRoot.querySelectorAll("input");
		
		$(this.cell).on("keydown", e => {
			e.preventDefault();

			switch (e.code) {
			case "Space":
				var index = -1;
				$(this.#target).each((i,el) => {
					if (this.value == el.getAttribute("value")) {
						index = i;
						return false;
					}
				});
				
				index = (index == this.#target.length - 1) ? 0 : ( index >= 0 ? index+1 : 0 );

				this.value = this.#target[index].getAttribute("value");
				break;
			}
		});
	};
	
	dataRefresh = (v) => {
	
		if (this.#dataSource) {
			this.#isValid() ? ninegrid.j.querySelectorAll(this).removeClass("invalid") : ninegrid.j.querySelectorAll(this).addClass("invalid");
		}

		$(this.#target).each((i,el) => {
			$(el).prop('checked', (this.value == el.getAttribute("value")) ? true : false);
		});

		if (!v) this.reset();
	};
	
	#isValid = () => {
		
		//console.log(this.value, ninegrid.isNull(this.value));
		
		if (ninegrid.isNull(this.value)) return true;

		var idx = this.#dataSource.findIndex(m => { return this.value == m[this.#code]; });
		if (idx < 0) return false;
		
		return true;
	};
	
	get dataSource() {
		return this.#dataSource;
	};
	
	
	#init = () => {
		
	};
};

if (!customElements.get('ng-radio')) {
	customElements.define("ng-radio", ngRadio);
}
